import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectEditRecordDialogData } from 'store/records/selectors/records.selectors';
import postRecordAllowance from '../services/postRecordAllowance.service';

export const addRecordAllowance = createAsyncThunk(
  'recordAllowances/addRecordAllowance',
  async ({ allowanceType, unitCount }, { getState }) => {
    const editRecordDialogData = selectEditRecordDialogData(getState());

    const { id, project } = editRecordDialogData;

    const response = await postRecordAllowance({
      allowanceType,
      unitCount,
      projectId: project,
      recordId: id,
    });
    return response;
  }
);
